module.exports = {
  common: {
    save: 'Save',
    cancel: 'cancel',
    combinationTitle: 'Automatic release rules (combination)',
    ruleTitle: 'Rules for automatic release',
    AutomaticOrderReleaseTriggerSettings: 'Automatic order release trigger settings',
    ReleaseGuaranteeSetting: 'Release guarantee setting',
    docType: 'Bill of lading type',
    customerSelfRelease: 'HBL type',
    releaseType: 'Bill of lading method',
    cargoSource: 'Source of goods collection',
    creditObject: 'Release information control object',
    receivableType: 'Revenue expense type',
    creditLimitedDate: 'Credit control accounting period',
    creditLimitAmount: 'Credit control limit',
    customerType: 'Type of entrusted unit'
  },
  selectBranch: 'Select a branch:',
  ApplyTheHeadOfficeConfiguration: 'Apply the head office configuration',
  enterRuleName: 'Please enter the rule name',
  add: 'Add',
  edit: 'Edit',
  deletes: 'Delete',
  refresh: 'Refresh',
  ruleName: 'Name of automatic release rule',
  businessTypes: 'Applicable business types',
  conversionRules: 'Relevant processing rules',
  ruleDescription: 'Description',
  orderNum: 'Serial number',
  ruleGroupName: 'Name of automatic release rule (combination)',
  ruleNames: 'Include rule names',
  performActions: 'Include execution actions',
  officeCode: 'Branch',
  customerCompany: 'Applicable to customers',
  refreshSuccess: 'Refresh succeeded',
  operationSuccess: 'Operation succeeded',
  dialogRuleName: 'Rule (combination) name',
  RuleNamePlaceholder: 'Please enter the rule name',
  ruleDescriptionPlaceholder: 'Description',
  AnyRuleTitle: 'Any of the following rules apply',
  AllRuleTitle: 'All the following rules apply',
  PerformRelatedActions: 'Perform related actions',
  meetConditions: 'satisfy',
  meetConditionsRemind: 'Automatic release. (The status is updated to "Release Available") ',
  dissatisfaction: 'discontent',
  runningRules: 'Run the next rule combination',
  runningRulesRemind: 'No order.(The status is updated to "Release Available")',
  remark1: 'Remarks: when "Run the next rule combination" is selected for all combinations "Not meeting the conditions", and the actual running judgment result is not meeting the conditions.',
  remark2: 'The release status will also be updated to "To Collection"',
  applicableCustomers: 'Applicable customers',
  applicableCustomersRemind1: 'Automatic release is only applicable to customers whose settlement type is "non bill settlement"',
  applicableCustomersRemind2: '(customers with existing accounting periods)',
  conditionType: 'Condition type',
  customerName: 'Customer name',
  branchOffice: 'Branch',
  successRemind: 'Saving succeeded',
  toggleReminder: 'Please confirm again whether you want to switch the applicable customers to all? This operation will clear the customer information in the list below. ',
  tips: 'Prompt',
  yes: 'Yes',
  no: 'No',
  deleteRemind: 'Please select at least one piece of data to delete!',
  ruleName1: 'Rule Name',
  meetAnyConditions: 'Any of the following conditions are met',
  meetAllConditions: 'All of the following conditions are met',
  processingRules: 'Release Processing Rules',
  releaseDemand: 'Release on demand',
  prompt: 'Please maintain the ${prompt} information before saving.',
  Tips1: 'Please complete the rule information',
  equal: 'be equal to',
  neq: 'Not equal to',
  exceed: 'exceed',
  notMore: 'Not more than',
  SC: 'Self collection',
  NC: 'Specified goods',
  creditUsedLimitAmount: 'Used quota',
  customerIssuing: 'Customer self issuing',
  issuedCompany: 'Self issued by the company',
  original: 'original',
  telexRelease: 'Telex Release',
  accountingPeriod: 'Credit Control Set Accounting Period',
  client: 'Client',
  agent: 'Designated freight agent',
  settlement: 'Settlement object',
  collection: 'Collection',
  maintenanceName: 'Maintenance Rule (Combination) Name',
  rule: 'rule',
  whole: 'whole',
  TriggerTheNode: 'Trigger The Node',
  ScheduledPollingTriggersAutomaticOrderVerification: 'Scheduled polling triggers automatic order verification',
  ApplyBranchOfficeSettings: 'Apply branch office settings',
  automatic: 'automatic',
  daily: 'daily',
  blacklist: 'blacklist',
  EffectiveList: 'Effective List',
  ChargeRecordState: 'Cost entry status judgment',
  ChargeRecordState0: 'Must include receivable expenses',
  ChargeRecordState1: 'Must include fees settled with the customer, regardless of payment or receipt',
  ChargeRecordState2: 'Regardless of whether there are fees or not',
  SettlementBillMode: 'Payment and release mode',
  SettlementBillCheckCost: 'When there are no other receivables, entering the payable to the entrusting unit is considered as payment',
  SettlementBillCustomer: 'Only verify that the accounts receivable of the entrusted unit have been written off',
  SettlementBillCustomerCheckCost: 'When there is no receivable from the entrusting unit, entering the payable to the entrusting unit is considered as payment made by the entrusting unit',
  CreditObjectMode: 'Signal control mode'
}
